import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ProjectService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  public static readonly URL_PROJECT_CONTROLLER = environment.apiUrl + '/project/';

  public static readonly URL_SAVE_USER_PROJECT_LIST = ProjectService.URL_PROJECT_CONTROLLER + "getAllProject/";
  public static readonly URL_PROJECT_LIST_WITH_PERC_BY_ID = ProjectService.URL_PROJECT_CONTROLLER + "getAllProjectWithPercentage/";

  getProjectListByUserID(id) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(ProjectService.URL_SAVE_USER_PROJECT_LIST + id + '/' + userToken, id)
      .pipe(catchError(this.handleError('Request Failed')));
  }


  getProjectListByUserIDWitPer(id) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(ProjectService.URL_PROJECT_LIST_WITH_PERC_BY_ID + id + '/' + userToken, id)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      console.log(error);
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }
}
